import { useState, useEffect } from 'react';
import axios from 'axios';
import { GEOSERVER } from 'config/URL/URL';
import GeoJSON from 'ol/format/GeoJSON';
import { dataList } from 'components/lab/lab_1/point_data/dataList';
import { delay } from 'motion';
import { forEach } from 'mathjs';


export const usePointData = () => {
    const [selectedCategory, setSelectedCategory] = useState();
    const [featureCollection, setFeatureCollection] = useState([]);
    const [mode, setMode] = useState();
    const [selectedRadioOption, setSelectedRadioOption] = useState();
    const [pointVectorLayerVisible, setPointVectorLayerVisible] = useState(false);
    const [selectedData, setSelectedData] = useState();
    const [selectedSubArray, setSelectedSubArray] = useState([]);
    const [mapData, setMapData] = useState();
    const [imageLayerVisible, setImageLayerVisible] = useState(true);
    const [imageLayerOpacity, setImageLayerOpacity] = useState(1);
    const [status, setStatus] = useState(false);

    const [renderCnt, setRenderCnt] = useState(0) ;


    // 초기 모드 설정
    useEffect(() => {
        // 기본값 설정
        const defaultData = dataList.find((data) => data.id === 4);
        setSelectedData(defaultData);
    }, []);

    useEffect(() => {
        setRenderCnt(renderCnt + 1);

        if(selectedSubArray.length > 0 && renderCnt < 2) {
            handleRadioChange(selectedSubArray[0])
        } 
    }, [selectedSubArray])

    useEffect(() => {
        if(featureCollection.length > 0 && renderCnt < 4) {
            setMode('pointTimeMap');
        }
    }, [featureCollection])

    useEffect(() => {
        if(status && renderCnt > 2 && renderCnt < 4) {
            const startButton = document.getElementById("intervalStartButton");
            
            setTimeout(() => {
                startButton.click();
            }, 1000)
        }
    }, [status])


    // 선택된 데이터에 따른 하위 배열 설정
    useEffect(() => {
        if (selectedData) {
            const subArray = selectedData.sub.map((data) => ({ ...data, checked: false }));
            setSelectedSubArray(subArray);

            if (mode === 'pointTimeMap' && selectedData.name !== '폐업음식점(2020)') {
                setMode('pointMap');
            } else if (mode === 'circleTimeMap' && selectedData.name !== '폐업음식점(covid)') {
                setMode('pointMap');
            }
        }
        return () => {
            setSelectedSubArray([]);
            setFeatureCollection([]);
        };
    }, [selectedData]);

    // 모드 변경 시 포인트 벡터 레이어 초기화
    useEffect(() => {
        setPointVectorLayerVisible(false);
        setSelectedRadioOption();
    }, [mode]);

    // 피처 컬렉션 상태 관리
    useEffect(() => {
        if (featureCollection.length > 0) {
            setStatus(true);
        } else {
            setStatus(false);
        }

        return () => {
            setStatus(false);
        };
    }, [featureCollection]);

    // 데이터 레이어 포인트 소스 가져오기
    const getDataLayerPointSource = async (sub) => {
        const { tableName, propertyName } = selectedData;
        const param = sub.param;

        const option = {
            params: {
                service: 'WFS',
                version: '1.3.0',
                request: 'GetFeature',
                typeName: `gis_solution:${tableName}`,
                maxFeatures: 50,
                outputFormat: 'application/json',
                propertyName: propertyName,
                viewparams: `param:${param};`,
            },
        };

        try {
            const response = await axios.get(`${GEOSERVER}/geoserver/gis_solution/ows`, option);
            return response;
        } catch (error) {
            console.log(error);
        }
    };

    // 체크박스 변경 핸들러
    const handleCheckboxChange = async (sub) => {
        setSelectedSubArray((prevArray) =>
            prevArray.map((item) => (item.id === sub.id ? { ...item, checked: !item.checked } : item))
        );

        if (!sub.checked) {
            const response = await getDataLayerPointSource(sub);
            const featureArray = response.data.features;

            const resultArray = featureArray.map((feature) => {
                const newFeature = new GeoJSON().readFeature(feature);
                return newFeature;
            });

            setFeatureCollection((prev) => [...prev, { id: sub.id, featureArray: resultArray }]);
        } else {
            setFeatureCollection((prev) => prev.filter((item) => item.id !== sub.id));
        }
    };

    // 라디오 버튼 변경 핸들러
    const handleRadioChange = async (sub) => {
        setSelectedSubArray((prevArray) =>
            prevArray.map((item) => (item.id === sub.id ? { ...item, checked: true } : { ...item, checked: false }))
        );

        
        if (!sub.checked) {
            const response = await getDataLayerPointSource(sub);
            const featureArray = response.data.features;

            const resultArray = featureArray.map((feature) => {
                const newFeature = new GeoJSON().readFeature(feature);
                return newFeature;
            });

            setFeatureCollection([{ id: sub.id, featureArray: resultArray }]);
        }
    };

    // 이미지 레이어 가시성 변경 핸들러
    const onChangeVisibleHandle = (e) => {
        setImageLayerVisible(e.target.checked);
    };

    // 투명도 변경 핸들러
    const onChangeOpacityHandle = (e) => {
        const opacity = parseFloat(e.target.value);
        setImageLayerOpacity(opacity);
    };

    return {
        // 상태
        selectedCategory,
        featureCollection,
        mode,
        selectedRadioOption,
        pointVectorLayerVisible,
        selectedData,
        selectedSubArray,
        mapData,
        imageLayerVisible,
        imageLayerOpacity,
        status,

        // 상태 설정 함수
        setSelectedCategory,
        setMode,
        setSelectedRadioOption,
        setPointVectorLayerVisible,
        setSelectedData,
        setMapData,

        // 이벤트 핸들러
        handleCheckboxChange,
        handleRadioChange,
        onChangeVisibleHandle,
        onChangeOpacityHandle,
    };
}; 